import { gql } from '@apollo/client';

export const FILTERED_FUNDER_DISTRICTS = gql`
  query FilteredFunderDistricts($input: FilterArgs!) {
    districts: filteredFunderDistricts(input: $input) {
      id
      name
    }
  }
`;
